import { ref, unref, inject, computed } from 'vue'
import { FormItemContextKey, FormContextKey } from '@sgui-plus/components/form/src/constants'
import { useProp } from '../use-prop'
import { useGlobalSize } from '../use-size'
import type { ComponentSize } from '@sgui-plus/utils/size'
import type { MaybeRef } from '@vueuse/core'

export const useSize = (
  fallback?: MaybeRef<ComponentSize | undefined>,
  ignore: Partial<Record<'prop' | 'form' | 'formItem' | 'global', boolean>> = {}
) => {
  const emptyRef = ref(undefined)

  const size = ignore.prop ? emptyRef : useProp<ComponentSize>('size')
  const globalConfig = ignore.global ? emptyRef : useGlobalSize()
  const form = ignore.form ? { size: undefined } : inject(FormContextKey, undefined)
  const formItem = ignore.formItem
    ? { size: undefined }
    : inject(FormItemContextKey, undefined)

  return computed(
    (): ComponentSize =>
      size.value ||
      unref(fallback) ||
      formItem?.size ||
      form?.size ||
      globalConfig.value ||
      'default'
  )
}

export const useDisabled = (fallback?: MaybeRef<boolean | undefined>) => {
  const disabled = useProp<boolean>('disabled')
  const form = inject(FormContextKey, undefined)
  return computed(
    () => disabled.value || unref(fallback) || form?.disabled || false
  )
}
